/* Joy of Small Things — lightweight wishlist hearts.
   Saves product ids in localStorage on this device only.
   No account, no app: the heart simply remembers what a shopper saved. */
(function () {
  var KEY = 'jost-wishlist';

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable — hearts still toggle for this view */
    }
  }

  function paintAll() {
    var list = read();
    document.querySelectorAll('[data-jost-wish]').forEach(function (btn) {
      var active = list.indexOf(btn.getAttribute('data-jost-wish')) !== -1;
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-jost-wish]') : null;
    if (!btn) return;
    event.preventDefault();
    var id = btn.getAttribute('data-jost-wish');
    var list = read();
    var idx = list.indexOf(id);
    if (idx === -1) {
      list.push(id);
    } else {
      list.splice(idx, 1);
    }
    write(list);
    paintAll();
  });

  /* Facet filtering swaps the grid HTML in place — repaint when new cards arrive. */
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        paintAll();
        break;
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintAll);
  } else {
    paintAll();
  }
})();
